var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.6191,
    cy: 39.344,
    r: 38.801,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_4451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7216 21.9609C36.8506 21.9609 31.2607 27.5352 31.2607 34.387C31.2607 41.2388 36.8506 46.8131 43.7216 46.8131C50.5926 46.8131 56.1824 41.2388 56.1824 34.387C56.1824 27.5352 50.5926 21.9609 43.7216 21.9609V21.9609ZM49.9996 35.3546H42.754V28.1251H44.6892V33.4195H49.9996V35.3546Z",
    fill: "#4A7FA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1104 45.3438L29.2849 40.1838L30.6511 41.5538L25.4765 46.7138L24.1104 45.3438Z",
    fill: "#4A7FA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1819 38.9492L27.9455 34.199L29.3117 35.5691L24.548 40.3193L23.1819 38.9492Z",
    fill: "#4A7FA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8613 53.5898L42.625 48.8396L43.9912 50.2096L39.2275 54.9599L37.8613 53.5898Z",
    fill: "#4A7FA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4951 51.2812L31.5425 45.251L32.9086 46.621L26.8613 52.6513L25.4951 51.2812Z",
    fill: "#4A7FA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4502 52.6602L36.6248 47.5002L37.9909 48.8702L32.8164 54.0302L31.4502 52.6602Z",
    fill: "#4A7FA7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_4451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(23.1829 21.9609)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuick);
export default __webpack_public_path__ + "static/media/quick.023efb95de15738d7cf2c88bfd6998e3.svg";
export { ForwardRef as ReactComponent };